import { createFileRoute } from '@tanstack/react-router'
import { Analytics } from '@/features/analytics'
import { requireAdmin } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/analytics/')({
  beforeLoad: requireAdmin,
  component: Analytics,
})
